export enum PayloadType {
  Connect = 'Connect',
  Error = 'Error',
  Whisper = 'Whisper',
  InitializePreviewResponse = 'InitializePreviewResponse',
  SeatSelectionChanged = 'SeatSelectionChanged',
  SeatPreviewStatesChanged = 'SeatPreviewStatesChanged',
  DiscountChanged = 'DiscountChanged',
  BusinessChanged = 'BusinessChanged',
  SeatSelectionRequest = 'SeatSelectionRequest',
}
